/**
 * Capitalizes the first letter of a string and converts the rest to lowercase.
 * @param {string} str - The input string to be processed
 * @returns {string} The string with first letter capitalized and rest lowercase
 * @example
 * capitalizeFirstLetter('hello') // returns 'Hello'
 * capitalizeFirstLetter('WORLD') // returns 'World'
 */
export const capitalizeFirstLetter = (str: string): string => {
    str = str.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
};
